import PositionMergeModal from '@web/positions/PositionMerge/PositionMergeModal';

import r2a from '../../angularIntegration/r2a';

export default r2a({
  ReactComponent: PositionMergeModal,
  bindings: {
    isOpen: '<',
    fromPositions: '<',
    availablePositions: '<',
    onSubmit: '&',
    onClose: '&',
  },
});
